import React, { Component } from "react";
import { focusTitle } from "./aria";

class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = { date: new Date() };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      date: new Date()
    });
  }

  render() {
    return (
      <div className="deadlines">
        <hr key="a" />
        <p key="b">
          Current time:
          <br />
          {this.state.date.toLocaleString()}
        </p>
        {"application" in this.props && "dateClose" in this.props.application && (
          <p key="c">
            Application deadline:
            <br />
            {this.props.application.dateClose.toDate().toString()}
          </p>
        )}
      </div>
    );
  }
}

const FormNav = ({
  appID,
  isApplicationOpen,
  application,
  history,
  logout,
  location,
  match,
  pageErrors,
  orientation = "horizontal",
  setDestination,
  isSubmitted,
  user
}) => {
  let nav = {
    pageNum: parseInt(match.params.page, 10),
    totalPages: application.schemas.length,
    startLink: `/${application.slug}/welcome`,
    reviewLink: `/${application.slug}/review`,
    helpLink: `/${application.slug}/help`
  };
  if (nav.pageNum + 1 > nav.totalPages) {
    nav.pageNum = nav.totalPages - 1;
    history.push(`/${application.slug}/form/0`);
  }
  nav.displayPage = nav.pageNum + 1;
  nav.prevPageLink =
    nav.pageNum - 1 >= 0
      ? `/${application.slug}/form/${nav.pageNum - 1}`
      : false;
  nav.nextPageLink =
    nav.pageNum + 1 < nav.totalPages
      ? `/${application.slug}/form/${nav.pageNum + 1}`
      : false;
  nav.finalPage = nav.nextPageLink === false;

  let wrapperClass =
    orientation === "vertical"
      ? "nav flex-column"
      : "pagination justify-content-center";
  let itemClass = orientation === "vertical" ? "nav-item" : "page-item";
  let linkClass =
    orientation === "vertical" ? "nav-link btn btn-link" : "page-link";

  let navPages = [];

  if (nav.totalPages > 1 && !isSubmitted) {
    for (let i = 0; i < nav.totalPages; i++) {
      let pageClass = nav.pageNum === i ? "nav-item active" : "nav-item";
      navPages.push(
        <li className={pageClass} key={"pagenav" + i}>
          <button
            type="submit"
            className={
              i === nav.pageNum
                ? linkClass + " text-secondary active"
                : linkClass + " text-primary"
            }
            onClick={() => setDestination(`/${application.slug}/form/${i}`)}
          >
            {orientation === "vertical"
              ? i + 1 + ". " + application.schemas[i].schema.title
              : i + 1}
          </button>
        </li>
      );
    }
  }

  return (
    <div
      id={orientation === "vertical" ? "primaryNav" : ""}
      className={
        orientation === "vertical"
          ? "col col-md-4 col-lg-3 d-md-block collapse"
          : "float-md-right"
      }
    >
      <nav
        className={
          orientation === "vertical" ? "sticky-top py-4" : "float-md-right"
        }
        aria-label="Form Application Steps"
      >
        <a className="show-on-focus" onClick={focusTitle}>
          Skip Navigation
        </a>
        {orientation === "vertical" && (
          <h1 className="h5">
            {"logo" in application ? (
              <img
                src={application.logo}
                className="logo"
                alt={application.name}
              />
            ) : (
              application.name
            )}
          </h1>
        )}

        {orientation === "vertical" && (
          <ul className={wrapperClass}>
            {"welcome" in application.content && (
              <li className={itemClass}>
                <button
                  type="submit"
                  className={
                    match.path === "/:application/welcome"
                      ? linkClass + " text-secondary active"
                      : linkClass
                  }
                  onClick={() => setDestination(nav.startLink)}
                >
                  Welcome
                </button>
              </li>
            )}

            {isApplicationOpen && navPages}

            <li className={itemClass}>
              <button
                type="submit"
                className={
                  match.path === "/:application/review"
                    ? linkClass + " text-secondary active"
                    : linkClass
                }
                onClick={() => setDestination(nav.reviewLink)}
              >
                Review
              </button>
            </li>

            <li className="navbar-text">
              <hr />
              Logged in {user.displayName && (
                <span>as {user.displayName}</span>
              )}{" "}
            </li>

            <li className="nav-item">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={logout}
              >
                Logout
              </button>
            </li>

            <Clock application={application || {}} />
            {"help" in application.content && (
              <li className="navbar-text">
                <p>
                  <button
                    type="submit"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setDestination(nav.helpLink)}
                  >
                    Help
                  </button>
                </p>
              </li>
            )}
            <li className="fine-print">
              <a href="https://www.obama.org/terms-conditions/" target="_blank">
                Terms &amp; Conditions
              </a>
            </li>
          </ul>
        )}

        {orientation === "simple" && (
          <div>
            {nav.nextPageLink && (
              <button
                type="submit"
                className="btn btn-primary nav-btn"
                onClick={() => setDestination(nav.nextPageLink)}
              >
                Save and Continue
              </button>
            )}
            {nav.finalPage && (
              <button
                type="submit"
                className="btn btn-primary nav-btn"
                onClick={() => setDestination(nav.reviewLink)}
              >
                Save and Review
              </button>
            )}
          </div>
        )}
      </nav>
    </div>
  );
};

export default FormNav;



// WEBPACK FOOTER //
// ./src/FormNav.js